import React from 'react';

const CONTEXT_KEY = Symbol.for('@thd-olt-component-react/product-list/Context');
const globalSymbols = Object.getOwnPropertySymbols(global);
const hasContext = (globalSymbols.indexOf(CONTEXT_KEY) > -1);

const funcDefault = () => {
  // This is intentional
};

if (!hasContext) {
  global[CONTEXT_KEY] = React.createContext({
    list: {},
    productsDisplayed: [],
    selectedItems: [],
    selectedGroups: [],
    isSharedList: false,
    isRemoving: false,
    onProductSelectionChange: funcDefault,
    onGroupSelectionChange: funcDefault,
    onDelete: funcDefault,
    onEditSuccess: funcDefault,
    closeSettings: funcDefault,
    onSuccesfulMaterialsAdd: funcDefault,
    refetch: funcDefault,
    clearListFromCache: funcDefault,
    productList: [],
    duplicateIntent: funcDefault,
    // Replace feature state
    replacingItemId: null,
    replacingIntentId: null,
    replacingGroupId: null,
    replacingIntent: null,
    replacingQuantity: 1,
    isReplaceMode: false,
    setReplaceMode: funcDefault,
    cancelReplaceMode: funcDefault,
    executeReplace: funcDefault
  });
}

export const ProductListContext = global[CONTEXT_KEY];
